<!-- =========================================================================================
  File Name: slide.vue
  Description: Setting Slide
========================================================================================== -->

<template>
  <div id="setting-slide">

    <vx-card title="轮播图设置">
      <div slot="actions">
        <vs-button color="success" size="small" type="filled" @click="add">添加轮播图</vs-button>
      </div>
      <vs-table stripe :data="list" noDataText="暂无滚动图">
        <template slot="thead">
          <vs-th width="200">APP轮播标题</vs-th>
          <vs-th width="380">PC端图片链接</vs-th>
          <vs-th width="380">APP副文本</vs-th>
          <vs-th width="380">APP端图片链接</vs-th>
          <vs-th width="200">排序(数值越小越靠前)</vs-th>
          <vs-th width="300">操作</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="index" v-for="(item, index) in list" >
            <vs-td :data="item.title">
              <vs-input v-model="item.title" class="w-full" />
            </vs-td>
            <vs-td :data="item.img">
              <vs-input v-model="item.img" class="w-full" />
            </vs-td>
            <vs-td :data="item.wapUrl">
              <vs-input v-model="item.wapUrl" class="w-full" />
            </vs-td>
            <vs-td :data="item.appUrl">
              <vs-input v-model="item.appUrl" class="w-full" />
            </vs-td>
            <vs-td :data="item.sort">
              <vs-input-number v-model="item.sort"/>
            </vs-td>
            <vs-td>
              <vs-button color="primary" type="filled" size="small" @click="modify" :data-index="index" :data-cmd="item.id == -1 ? 'add' : 'mod'">{{item.id == -1 ? '添加' : '更改'}}</vs-button>
              <vs-button color="danger" type="border" size="small" @click="modify" :data-index="index" data-cmd="del" class="ml-5">删除</vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <vs-button class="mt-5" color="success" type="filled" size="small" @click="add">添加轮播图</vs-button>
    </vx-card>

  </div>
</template>

<script>

export default {
  data() {
    return {
      list: []
    }
  },
  methods: {
    modify (e) {
      const dataset = e.currentTarget.dataset
      const postdata = this.list[dataset.index]
      postdata.authKey = localStorage.getItem('authKey')
      postdata.cmd = dataset.cmd
      // 如果是删除，则需要确认
      if (postdata.cmd == 'del') {
        // 如果还没添加，则直接删除
        if (postdata.id == -1) {
          this.list.splice(dataset.index, 1)
          return
        }
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: '确认',
          text: '确认删除本条轮播图吗?',
          acceptText: '确认',
          cancelText: '取消',
          accept: () => {
            this.modifyRequest(postdata)
          }
        })
      } else {
        this.modifyRequest(postdata)
      }
    },
    modifyRequest (postdata) {
      this.$utils.post('setting-slideDo', postdata).then(res => {
        this.$vs.dialog({
          title: '提示',
          text: res,
          acceptText: '确认'
        })
        this.load()
      })
    },
    add () {
      this.list.push({ id: -1, sort: 0 })
    },
    load () {
      this.$utils.post('setting-slideList', { authKey: localStorage.getItem('authKey') }).then(res => {
        this.list = res
      })
    }
  },
  mounted () {
    this.load()
  }
}
</script>
